import React, { Component } from 'react'
import { DISPATCH_ID } from '../../libs/utils/Const';
import { connect } from 'react-redux';
import { BreadCumb, NavBar, DataTables } from "../../components/index";
import config from "../../config";
import { ApiClient } from '../../libs/apiClient';
import moment from "moment";
const headersDataTable = [
    { title: "ID Resultado", value: true },//0
    { title: "Estatus", value: true },//1
    { title: "Socio de negocio", value: true },//2
    { title: "Nombre del negocio", value: true },//3
    { title: "ID. Creador (Vendedor)", value: true },//4
    { title: "Fecha", value: true },//5
    { title: "Solicitud", value: true },//6
    { title: "Comentarios", value: true },//7
];
let apiClient = ApiClient.getInstance();

class AuthorizePartners extends Component {
    constructor(props) {
        super(props)
        this.state = {
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
            itemsDashboard: JSON.parse(localStorage.getItem(config.localStorageNamed + 'itemsDashboard')),
            headers: headersDataTable,
            data: [],
            total: 0
        }
    }
    componentDidMount (){
        const dataInfo = {
            dateInit: moment(document.getElementById("fechaInicio").value).format('YYYY-MM-DD'),
            dateFinal: moment(document.getElementById("fechaFin").value).format('YYYY-MM-DD'),
            docStatusSearchAuthoBP: 'W'
        }
        this.GetAuthoBusinessPartners(dataInfo);
    }

    GetAuthoBusinessPartners = async (dataInfo) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props
        if (dataInfo.docStatusSearchAuthoBP === '') {
            showAlert({ type: 'warning', message: `Selecciona el estatus a buscar.`, timeOut: 10000 });
            return;
        }
        const data = {
            status: dataInfo.docStatusSearchAuthoBP,
            initialDate: dataInfo.dateInit,
            finalDate: dataInfo.dateFinal,
        }
        enableSpinner(true)
        const responseApi = await apiClient.getAuthoBusinessPartners(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'info', message: `${responseApi?.message ?? ''}` });
            this.setState({
                data: [],
            });
            return;
        }

        if (responseApi.data && responseApi.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            this.setState({
                data: [],
            });
            return;
        }

        await this.setState({
            data: responseApi.data || [],
            total: responseApi.data.length || 0
        });
    }

    render() {
        const { itemsDashboard, headers, data, total } = this.state
        return (
            <>
                <div className="content">
                    <NavBar props={this.props} itemsDashboard={itemsDashboard} />
                    <BreadCumb subitem1={'ADMINISTRADOR DE SOCIOS DE NEGOCIOS'} url1={'#'} />
                    <div style={{ marginLeft: "4.5rem" }}>
                        <h2 className="md-display-1">
                            AUTORIZACIONES DE SOCIOS DE NEGOCIOS
                        </h2>
                        <DataTables
                            headers={headers}
                            view={"authorizePartners"}
                            data={data}
                            search={this.GetAuthoBusinessPartners}
                            totalRows={total} />
                    </div>


                </div>
            </>
        )
    }
}


const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AuthorizePartners);